import { useHistory, useParams } from "react-router-dom";
import { useIndustrySpecialist } from "./hooks/useIndustrySpecialist";
import IndustrySpecialistsLoader from "./components/skeletons/EditIndustryPageSkeleton";
import ErrorPage from "../shared/components/BaseError";
import EntityPageLayout from "../shared/components/EntityPageLayout";
import { useIntl } from "react-intl";
import BaseButton from "components/common/BaseButton";
import useMutateIndustrySpecialist from "./hooks/useMutateIndustrySpecialist";
import { useState } from "react";
import DeletionModal from "../shared/components/DeletionModal";

const ViewIndustrySpecialistPage = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEntityId, setSelectedEntityId] = useState<string | null>(null);
  const [entityName, setEntityName] = useState("");

  const history = useHistory();

  const intl = useIntl();

  const { entityId } = useParams<{
    entityId: string;
  }>();

  const {
    data: is,
    isLoading,
    isError,
    error,
    refetch,
  } = useIndustrySpecialist({ industrySpecialistId: entityId });

    const {
      deleteIndustrySpecialist,
      deleteIndustrySpecialistLoading,
      deleteIndustrySpecialistSuccess,
      deleteIndustrySpecialistReset,
      deleteIndustrySpecialistIsError,
    } = useMutateIndustrySpecialist({ id: selectedEntityId as string });
  
    const handleDelete = () => {
      const isName = is?.name || "";
      setSelectedEntityId(is?.id.toString() || "");
      setShowDeleteModal(true);
      setEntityName(isName);
    };

    const onEditClick = () => {
      history.push(`/us-admin-app/industry-specialists/${entityId}/edit`);
    }
  
    const confirmDelete = () => {
      if (selectedEntityId) {
        deleteIndustrySpecialist({ industrySpecialistId: selectedEntityId });
      }
    };

  if (isError)
    return (
      <EntityPageLayout headerMessage="usAdmin.viewIndustrySpecialist">
        <ErrorPage errorMessage={error} onRetry={refetch} />
      </EntityPageLayout>
    );

  if (isLoading)
    return (
      <EntityPageLayout headerMessage="usAdmin.viewIndustrySpecialist">
        <IndustrySpecialistsLoader />
      </EntityPageLayout>
    );

  return (
    <EntityPageLayout headerMessage="usAdmin.viewIndustrySpecialist">
      <div className="view-grid">
        <div className="view-container">
          <span className="view-container__title">{intl.formatMessage({ id: "usAdmin.name" })}</span>
          <span>{is?.name || "N/A"}</span>
        </div>
        <div className="view-container">
          <span className="view-container__title">{intl.formatMessage({ id: "usAdmin.email" })}</span>
          <span>{is?.email || "N/A"}</span>
        </div>
      </div>
      <div className="view-action-button-container">
        <BaseButton text={intl.formatMessage({ id: "usAdmin.edit" })} handleSubmit={onEditClick} />
        <BaseButton text={intl.formatMessage({ id: "usAdmin.delete" })} backgroundColor="red" handleSubmit={handleDelete} />
      </div>
      <DeletionModal
        isOpen={showDeleteModal || deleteIndustrySpecialistSuccess || deleteIndustrySpecialistIsError}
        isError={deleteIndustrySpecialistIsError}
        isSuccess={deleteIndustrySpecialistSuccess}
        loading={deleteIndustrySpecialistLoading}
        deletedEntityName={entityName}
        onClose={() => {
          setShowDeleteModal(false);
          deleteIndustrySpecialistReset();
        }}
        onConfirm={confirmDelete}
      />
    </EntityPageLayout>
  );
};

export default ViewIndustrySpecialistPage;
